<template>
  <div class="vmp-polling-setting">
    <vh-dialog
      :title="$t('host.k_608001')"
      :visible.sync="pollingVisible"
      :close-on-click-modal="true"
      :modal-append-to-body="true"
      width="560px"
    >
      <div class="vmp-polling-setting_warp">
        <div class="polling_form">
          <div class="polling_form_item">
            {{ $t('host.k_608002') }}
            <vh-select
              v-model="pollingForm.videoNum"
              :placeholder="$t('host.k_608003')"
              style="width: 120px"
            >
              <vh-option
                v-for="item in pollingNumList"
                :key="item.value"
                :label="item.label"
                :disabled="item.value > surplusSpeakCount"
                :value="item.value"
              ></vh-option>
            </vh-select>
          </div>
          <div class="polling_form_item">
            <vh-radio v-model="pollingForm.videoAutoPolling" :label="0">
              {{ $t('host.k_608004') }}
              <span class="item_color">{{ $t('host.k_608005') }}</span>
            </vh-radio>
            <vh-radio v-model="pollingForm.videoAutoPolling" :label="1">
              {{ $t('host.k_608006') }}
              <span class="item_color">{{ $t('host.k_608007') }}</span>
            </vh-radio>
            <div class="item_time">
              {{ $t('host.k_608008') }}
              <vh-select
                v-model="pollingForm.videoTime"
                :disabled="pollingForm.videoAutoPolling == 0"
                :placeholder="$t('host.k_608003')"
                style="width: 120px"
              >
                <vh-option
                  v-for="item in pollingTimeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></vh-option>
              </vh-select>
            </div>
          </div>
          <div class="polling_form_item">
            <p>{{ $t('host.k_608009') }}</p>
          </div>
        </div>
        <div class="vmp-polling-setting_btn">
          <vh-button type="info" plain round @click="closePolling">
            {{ $t('host.k_608010') }}
          </vh-button>
          <vh-button type="primary" round @click="startPolling">
            {{ $t('host.k_608011') }}
          </vh-button>
        </div>
      </div>
    </vh-dialog>
  </div>
</template>
<script>
  import { useVideoPollingServer } from 'middle-domain';
  export default {
    name: 'VmpPollingSetting',
    data() {
      return {
        pollingVisible: false,
        pollingForm: {
          videoNum: 1,
          videoAutoPolling: 0,
          videoTime: 30
        },
        pollingNumList: [
          {
            value: 1,
            label: 1
          },
          {
            value: 4,
            label: 4
          },
          {
            value: 9,
            label: 9
          }
        ],

        pollingTimeList: [
          {
            value: 30,
            label: this.$t('host.k_608012')
          },
          {
            value: 60,
            label: this.$t('host.k_608013')
          },
          {
            value: 300,
            label: this.$t('host.k_608014')
          },
          {
            value: 600,
            label: this.$t('host.k_608015')
          }
        ]
      };
    },
    computed: {
      surplusSpeakCount() {
        return this.$domainStore.state.videoPollingServer.surplusSpeakCount;
      },
      // 当前登录的角色 主持人/助理
      roleName() {
        return this.$domainStore.state.roomBaseServer.watchInitData.join_info.role_name;
      }
    },
    beforeCreate() {
      this.videoPollingServer = useVideoPollingServer();
    },
    methods: {
      showVideoPollingSetting() {
        this.getVideoPollingInfo();
      },
      getVideoPollingInfo() {
        this.videoPollingServer.getVideoRoundInfo().then(res => {
          if (res.code === 200) {
            const { account_id, role_name, max_speak_count, surplus_speak_count } = res.data;
            let title = '';
            if (account_id) {
              this.pollingVisible = false;
              if (
                localStorage.getItem(`isVideoPolling_${this.$route.params.id}`) == 1 &&
                this.$domainStore.state.roomBaseServer.watchInitData.join_info
                  .third_party_user_id == account_id
              ) {
                this.goPollingPage();
                return;
              } else {
                if (
                  this.$domainStore.state.roomBaseServer.watchInitData.join_info
                    .third_party_user_id == account_id
                ) {
                  title = this.$t('host.k_608016');
                } else {
                  title = this.$t('host.k_608017', [this.$getRoleName(role_name)]);
                }
                this.setPollingAlert(title);
                return;
              }
            }
            if (!surplus_speak_count) {
              this.pollingVisible = false;
              this.setSpeakCountAlert(max_speak_count);
              return;
            }
            this.pollingVisible = true;
          } else if (res.code === 513560) {
            this.pollingVisible = false;
            let title = this.$t('host.k_608018');
            this.setPollingAlert(title);
            return;
          } else {
            this.$message.error(res.msg);
            return;
          }
        });
      },
      // 开始轮巡
      startPolling() {
        let params = {
          round_video_count: this.pollingForm.videoNum,
          is_auto: this.pollingForm.videoAutoPolling,
          interval: this.pollingForm.videoTime
        };
        this.videoPollingServer.videoRoundStart(params).then(res => {
          if (res.code === 200) {
            // 上报数据
            this.setReportData();
            // 跳转页面
            this.goPollingPage();
          } else if (res.code === 13342) {
            this.setSpeakCountAlert();
          } else {
            this.$message.error(res.msg);
            return;
          }
        });
      },
      goPollingPage() {
        this.pollingVisible = false;
        this.resetFormData();
        const href = `${window.location.origin}${process.env.VUE_APP_ROUTER_BASE_URL}/lives/video-polling/${this.$route.params.id}${window.location.search}`;
        window.open(href, '_blank');
      },
      // 已经开启了轮巡
      setPollingAlert(title) {
        this.$vhAlert(title, '', {
          title: this.$t('host.k_608019'),
          confirmButtonText: this.$t('host.k_608020'),
          roundButton: true
        });
        return;
      },
      // 上麦人数已满弹窗
      setSpeakCountAlert(speakCount) {
        const maxSpeakCount = speakCount || this.videoPollingServer.state.maxSpeakCount;
        const h = this.$createElement;
        this.$vhAlert('', '', {
          title: this.$t('host.k_608019'),
          message: h('div', null, [
            h('p', { style: 'padding-bottom: 5px' }, this.$t('host.k_608021', [maxSpeakCount])),
            h('p', { style: 'color: #999' }, this.$t('host.k_608022'))
          ]),
          confirmButtonText: this.$t('host.k_608020'),
          roundButton: true
        });
        return;
      },
      // 上报数据
      setReportData() {
        window.vhallReportForProduct?.report(
          this.pollingForm.videoAutoPolling == 1 ? 110150 : 110149
        );
        window.vhallReportForProduct?.report(110151, {
          report_extra: { count: this.pollingForm.videoNum }
        });
      },
      // 重置表单
      resetFormData() {
        this.pollingForm = {
          videoNum: 1,
          videoAutoPolling: 0,
          videoTime: 30
        };
      },
      // 关闭弹窗
      closePolling() {
        this.pollingVisible = false;
        this.resetFormData();
      }
    }
  };
</script>
<style lang="less">
  .vmp-polling-setting {
    &_warp {
      .polling_form {
        color: #1a1a1a;
        &_item {
          padding-bottom: 16px;
          .vh-radio {
            padding-bottom: 16px;
            &__label {
              padding-left: 5px;
            }
          }
          .vh-radio__label {
            color: #1a1a1a;
          }
          .item_color {
            color: #666;
            white-space: normal;
          }
          .item_time {
            padding-left: 25px;
          }
          p {
            color: #999;
          }
        }
      }
    }
    &_btn {
      display: flex;
      justify-content: flex-end;
      align-content: center;
      .vh-button {
        display: inline-block;
        min-width: 90px;
        &.is-round {
          // padding: 7px 0;
        }
      }
    }
  }
</style>
